import React from 'react';
import Profilesidebar from '../components/Element/ClientSidebar';
import BranchesList from '../components/Element/Branch';
const Branches = (props) => {
	return (
		<React.Fragment>
			<div className="page-content bg-white">
				<div className="content-block">
					<div className="section-full bg-white browse-job p-t50 p-b20">
						<div className="container">
							<div className="row">
								<Profilesidebar page="branch"/>
								<div className="col-xl-9 col-lg-8 m-b30">
									<BranchesList />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

export default Branches;